import PropTypes from 'prop-types';
import { EssentialsListDescription } from './EssentialsListDescription.js';
import { EssentialsListCard } from './EssentialsListCard.js';
import { EssentialsListDonateButton } from './EssentialsListDonateButton.js';

/**
 * Like an {@link EssentialsListCard}, but subtler. Embed these into search-results when the user's search has nothing
 * to do with essentials-lists.
 *
 * This component's props should be kept in sync with EssentialsListCard so we can swap the two components out safely.
 */
export const EssentialsListPromo = ({
    teacherName, topItemName, topItemImageUrl, topItemPrice, listLength,
    state, stateFullName, city, essentialsListUrl, hideTeacherDetails, teacherId,
}) => {
    const location = (hideTeacherDetails || !city) ? stateFullName : `${city}, ${state}`;
    const costToDisplay = topItemPrice > 25 ? 10 : topItemPrice;

    return (
        <div className="essentials-list-card promo">
            <div className="top-supply" style={{ backgroundImage: 'url(' + topItemImageUrl + ')' }}></div>
            <div className="classroom-essentials-intro">
                <h3>Get basics for a classroom</h3>
                <p>
                    <EssentialsListDescription
                        isPromo={true}
                        location={location}
                        teacherName={teacherName}
                        topItemName={topItemName}
                        topItemPrice={costToDisplay}
                    />
                </p>
                <h4>(Currently not eligible for match offers)</h4>
            </div>
            <div className="list-details">
                <EssentialsListDonateButton teacherId={teacherId} topItemPrice={costToDisplay}>
                    <span className="name">Add to cart</span>
                    <span className="price">${costToDisplay}</span>
                </EssentialsListDonateButton>
            </div>
        </div>
    )
}
EssentialsListPromo.propTypes = {
    // See EssentialsListFeedVO
    teacherName: PropTypes.string.isRequired,
    topItemName: PropTypes.string.isRequired,
    topItemImageUrl: PropTypes.string.isRequired,
    topItemPrice: PropTypes.number.isRequired,
    listLength: PropTypes.number.isRequired,
    essentialsListUrl: PropTypes.string.isRequired,
    city: PropTypes.string,
    state: PropTypes.string,
    stateFullName: PropTypes.string,
    hideTeacherDetails: PropTypes.bool,
    teacherId: PropTypes.number.isRequired,
}

